module.exports = __webpack_public_path__ + "img/icon-youtube.d0c5449d.svg";